module.exports = __webpack_public_path__ + "img/horizontal_4_4_pp1_4.93a512fc.png";